import React from 'react';
import { usePlatform } from '../../contexts/PlatformContext';
import './PlatformDebugPanel.css';

/**
 * Platform context inspector for staff menus — does not render branding HTML or custom_css.
 */
export const PlatformContextDebugInfo: React.FC = () => {
  const {
    hostname,
    tenant,
    appSlug,
    enabled,
    branding,
    usedFallback,
    isLoading,
    error,
  } = usePlatform();

  return (
    <div className="platform-debug-info" aria-label="Platform context">
      <div className="platform-debug-info__heading">Platform context</div>
      <dl className="platform-debug-info__list">
        <div>
          <dt>hostname</dt>
          <dd>{hostname}</dd>
        </div>
        <div>
          <dt>tenant</dt>
          <dd>{tenant ? `${tenant.slug} (${tenant.display_name})` : '—'}</dd>
        </div>
        <div>
          <dt>app_slug</dt>
          <dd>{appSlug}</dd>
        </div>
        <div>
          <dt>enabled</dt>
          <dd>{enabled ? 'true' : 'false'}</dd>
        </div>
        <div>
          <dt>product_name</dt>
          <dd>{branding.product_name ?? '—'}</dd>
        </div>
        <div>
          <dt>fallback</dt>
          <dd>{usedFallback ? 'yes' : 'no'}</dd>
        </div>
        <div>
          <dt>loading</dt>
          <dd>{isLoading ? 'yes' : 'no'}</dd>
        </div>
        {error && (
          <div>
            <dt>error</dt>
            <dd>{error}</dd>
          </div>
        )}
      </dl>
    </div>
  );
};

export default PlatformContextDebugInfo;
